import { gql } from '@apollo/client';

export const UPDATE_AVATAR_MUTATION = gql`
  mutation UpdateAvatar($data: UpdateAvatarInput!) {
    updateAvatar(data: $data) {
      enqueued
    }
  }
`;
